import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useSearchParams, useNavigate } from "react-router-dom";
import { fetchOrderBySessionId,  } from "../utils/api"; 
import { FaCheckCircle, FaCreditCard } from "react-icons/fa";
import { useCart } from "../context/CartContext";
import Loading from "../components/Loading";
import logo from "../assets/logo.png";


const Success = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = searchParams.get("session_id");

    const [order, setOrder] = useState(null);
    
    const {clearCart} = useCart();

    useEffect(() => {
        if (!sessionId){
            navigate("/");
        } else {
            fetchOrder();
            clearCart();
        }
        
    }, [sessionId, navigate]);

    const fetchOrder = async () => {
        try {
            const data = await fetchOrderBySessionId(sessionId);
            setOrder(data);
        } catch (error) {
            console.error("Error fetching order:", error);
        }
    };
    console.log(order)

    const handleDownloadReceipt = () => {
        const receiptUrl = order.receiptUrl;
        
        if (!receiptUrl) {
            alert("Kvittering er ikke tilgjengelig.");
            return;
        }
    
        window.open(receiptUrl, "_blank");
    
        fetch(receiptUrl)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Kvittering.pdf";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => console.error("Feil ved nedlasting av kvittering:", error));
    };
    
    if (order === null) {
        return <Loading />;
    }

    return (
        <Container>
            <Content>
                <LeftSection>
                    <Logo>
                        <img src={logo} alt="wildberries" />
                    </Logo>
                    <Title>Betaling Godkjent</Title>
                    <Text>
                        Tusen takk for din bestilling! Din betaling er godkjent og ordren er bekreftet.
                    </Text>
                    <ButtonGroup>
                        <PrimaryButton onClick={handleDownloadReceipt}>Last Ned Kvittering</PrimaryButton>
                        <SecondaryButton onClick={() => navigate("/")} >Tilbake Til Hjem</SecondaryButton>
                    </ButtonGroup>
                </LeftSection>

                <RightSection>
                    <PriceCard>
                        <Amount>{order.totalAmount + order.deliveryFee} NOK</Amount>
                        <SuccessText>Betaling Godkjent</SuccessText>
                        <CheckIcon />
                    </PriceCard>

                    <PaymentDetails>
                        <DetailRow>
                            <Label>Dato</Label>
                            <Value>{new Date(order.createdAt).toLocaleDateString()}</Value>
                        </DetailRow>
                        <DetailRow>
                            <Label>Ordre #</Label>
                            <Value>{order._id}</Value>
                        </DetailRow>
                        <DetailRow>
                            <Label>Total Beløp</Label>
                            <Value>{order.totalAmount + order.deliveryFee} NOK</Value>
                        </DetailRow>
                        <DetailRow>
                            <Label>Betalingsmetode</Label>
                            <Value>
                                <FaCreditCard /> Bankkort
                            </Value>
                        </DetailRow>
                        <DetailRow>
                            <Label>Betalings Status</Label>
                            <SuccessStatus>
                                <FaCheckCircle /> Betalt
                            </SuccessStatus>
                        </DetailRow>
                    </PaymentDetails>
                </RightSection>
            </Content>
        </Container>
    );
};

export default Success;

const Container = styled.div`
    display: flex;
    padding: 1rem;
    margin-top: 35px;
    min-height: 100vh;
    
`;

const Content = styled.div`
    display: flex;
    width: 100%;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    gap: 40px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        padding: 20px;
    }
`;

const LeftSection = styled.div`
    flex: 1;
`;

const Logo = styled.div`

    @media (max-width: 768px) {
        display: flex;
        justify-content: center;
    }

    img {
        width: 80px;
        object-fit: contain;
        align-self: center;
    }
`;

const Title = styled.h1`
    font-size: 26px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
`;

const Text = styled.p`
    margin-bottom: 20px;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;

    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;
    }
`;

const PrimaryButton = styled.button`
    background: #2d6a4f;
    color: white;
    padding: 12px 18px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
        background: #1b4332;
    }
`;

const SecondaryButton = styled.button`
    background: transparent;
    color: #2d6a4f;;
    padding: 12px 18px;
    border: 1px solid #2d6a4f;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: #2d6a4f;
        color: white;
    }
`;

const RightSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const PriceCard = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    width: 100%;
    text-align: center;
    position: relative;
`;

const Amount = styled.h2`
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 5px;
`;

const SuccessText = styled.p`
    font-size: 14px;
    color: #28a745;
    margin-bottom: 10px;
`;

const CheckIcon = styled(FaCheckCircle)`
    color: #28a745;
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 24px;

    @media (min-width: 768px) {
        font-size: 32px;
        top: 10px;
        left: 10px;
        transform: none;
    }


`;

const PaymentDetails = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    width: 100%;
    margin-top: 20px;
    position: relative;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background-color: #fdf5e6;
        clip-path: polygon(0% 100%, 5% 60%, 10% 100%, 15% 60%, 20% 100%, 25% 60%, 30% 100%, 
                           35% 60%, 40% 100%, 45% 60%, 50% 100%, 55% 60%, 60% 100%, 65% 60%, 
                           70% 100%, 75% 60%, 80% 100%, 85% 60%, 90% 100%, 95% 60%, 100% 100%);
    }
`;

const DetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 28px;

    @media (min-width: 768px) {
        margin-bottom: 36px;
    }
`;

const Label = styled.span`
    font-weight: bold;
`;

const Value = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
`;

const SuccessStatus = styled(Value)`
    color: #2d6a4f;
    font-weight: bold;
`;